import { ConfigProvider } from 'antd';
import * as React from 'react';
import shallow from 'zustand/shallow';

import { Loader } from './components/Loader';
import { useI18n } from './hooks';
import { useSegment } from './hooks/useSegment';
import { Pages } from './pages';
import { api } from './services';
import { resetStores, useAppStore, useAuthStore } from './stores';

function App() {
  useSegment();

  const [loading, setLoading] = React.useState(false);
  const { loaded, setLoaded } = useAppStore((state) => state, shallow);
  const { init: initAuth, isAuthenticated, user } = useAuthStore((state) => state, shallow);
  const { antdConfig } = useI18n(user?.attributes?.locale);

  React.useEffect(() => {
    if (!loaded && !loading) {
      setLoading(true);

      initAuth().then(() => {
        setLoaded(true);
        setLoading(false);
      });
    }
  }, [initAuth, loaded, loading, setLoaded]);

  React.useEffect(() => {
    if (!isAuthenticated) {
      // We want to reset the stores after the new authentication state has been propagated
      // to all other subscribers (mainly components using the store hooks) so we do it in
      // the next tick.
      setTimeout(() => {
        resetStores();
        api.client.resetStore();
      }, 0);
    }
  }, [isAuthenticated]);

  return <ConfigProvider {...antdConfig}>{loaded ? <Pages /> : <Loader />}</ConfigProvider>;
}

export default App;
